import React from 'react';
import { Link } from 'react-router-dom';
import LogoWhite from './LogoWhite';
import Nav from './Nav';
import MobileMenu from './MobileMenu';
import OffCanvasStyleOne from './OffCanvasStyleOne';
import SearchButton from './SearchButton';
import { useTranslation } from 'react-i18next';
import LangSelector from '../../components/LangSelector';

const HeaderThreeSticky = ({ data }) => {
  const profile = data.length > 0 ? data[0] : null;
  const { t } = useTranslation();

  return (
    <div className="main-header-one__bottom">
      <div className="container-fluid">
        <div className="main-header-one__bottom-inner">
          <div className="main-header-one__bottom-left" style={{ flex: 1 }}>
            <nav className="main-menu main-menu--1">
              <div className="main-menu__inner">
                <LangSelector />
                <MobileMenu data={profile} />
                <div className="stricky-one-logo">
                  <LogoWhite />
                </div>
                <Nav />
              </div>
            </nav>
          </div>

          <div className="main-header-one__bottom-right">
            {/* <div className="search-box">
              <SearchButton />
            </div>

            <div className="cart-btn">
              <Link to={process.env.PUBLIC_URL + `/`}>
                <span className="icon-shopping-bag-1"></span>
                <span className="count">0</span>
              </Link>
            </div> */}

             {/* <LangSelector /> */}

            <div className="main-header-one__bottom-right-btn">
              <a
                href="#service-one"
                className="thm-btn"
                data-text={`${t('header.getStarted')} +`}
              >
                {t('header.getStarted')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderThreeSticky;
